import buscaInteligenteImg from '@/assets/onboarding/Onboarding-BuscaInteligente2x.png';
import mapadeAprendizagemImg from '@/assets/onboarding/Onboarding-MapadeAprendizagem2x.png';
import mefacaPerguntasImg from '@/assets/onboarding/Onboarding-MefacaPerguntas2x.png';
import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './style.scss';

const OnboardingDescription: React.FC = () => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    const history = useHistory();

    const buttonClickHandler = (): void => {
        history.push('/onboardingSelectionInterests');
    };

    return (
        <div className="onboarding-page-description">
            <div className="onboarding-page-container">
                <div className="onboarding-page-content">
                    <div className="onboarding-page-items">
                        <div className="onboarding-item">
                            <h3>{strings.ONBOARDING.MAKE_ME_QUESTIONS}</h3>
                            <img className="img-container" src={mefacaPerguntasImg} />
                            <p className="make-me-quesions-text">{strings.ONBOARDING.MAKE_ME_QUESTIONS_DESCRIPTION}</p>
                        </div>
                        <div className="onboarding-item">
                            <h3>{strings.ONBOARDING.SMART_SEARCH}</h3>
                            <img className="img-container" src={buscaInteligenteImg} />
                            <p>{strings.ONBOARDING.SMART_SEARCH_DESCRIPTION}</p>
                        </div>
                        <div className="onboarding-item">
                            <h3>{strings.ONBOARDING.LEARNING_MAP}</h3>
                            <img className="img-container" src={mapadeAprendizagemImg} />
                            <p>{strings.ONBOARDING.LEARNING_MAP_DESCRIPTION}</p>
                        </div>
                    </div>
                    <button className="btn btn-primary btn-sm new-item-button" onClick={buttonClickHandler} type="button">
                        {strings.UNDERSTAND}!
                    </button>
                </div>
            </div>
            <div className="bg-cinza"></div>
        </div>
    );
};

export default OnboardingDescription;
